import { gql } from '@apollo/client'

export const EDIT_SEGMENT = gql`
  mutation EditSegment($segmentId: ID!, $companyLineSpecs: [companyLineSpecInput!]!) {
    updateSegment(input: { id: $segmentId, companyLineSpecs: $companyLineSpecs })
  }
`

export const ADD_SEGMENT_COMPANY_LINE_SPEC = gql`
  mutation AddSegmentCompanyLineSpec($segmentId: ID!, $companyLineSpec: addCompanyLineSpecInput!) {
    addSegmentCompanyLineSpec(input: { id: $segmentId, companyLineSpec: $companyLineSpec })
  }
`
